// extracted by mini-css-extract-plugin
module.exports = {"switchTabWithImage":"TabModule_switchTabWithImage__MphP8"};